import React from "react";
import { Button, Toast } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { ChangeAuthenticationUIActionTypes, SettingsMessages } from "src/common";

type AllProps = {
  handleAction: ActionHandlerFunction;
  new_webkey: boolean;
}

// Description: Component to display a message when a web authentication key is created or changed.
function WebAuthKeyAddedComponent(props: AllProps) {
  const { handleAction, new_webkey } = props;
  const title = `Authentication Key ${new_webkey ? "Added" : "Updated"}`;
  const message = `Your Authentication key ${new_webkey ? "is on" : "has been updated"} for your account.`;

  return <>
    <h3>{title}</h3>
    <p>{message}</p>
    <p>Keep it with you so you can always sign into PreVeil and be FedRAMP compliant.</p>
    <Toast bg="warning" className="d-inline-block mb-3 mt-2">
      <Toast.Body>
        {SettingsMessages.web_auth_warning}
      </Toast.Body>
    </Toast>
    <Button onClick={() => handleAction({ actionType: ChangeAuthenticationUIActionTypes.ResetForms })}>Ok</Button>
  </>;
}

export default React.memo(WebAuthKeyAddedComponent);
